{
  "settings.title": "Settings",
  "settings.workshop": "Workshop",
  "settings.save": "Save changes",
  "settings.saving": "Saving …",
  "settings.saved": "Saved",
  "settings.discard": "Discard changes",
  "settings.unsaved": "You have changes that are not saved.",
  "settings.leave_warning": "You have unsaved changes. Leave the page anyway?",
  "settings.error": "That could not be saved. Try again.",
  "settings.retry": "Try again",
  "settings.load_error": "We could not load the settings.",
  "settings.cancel": "Cancel",
  "settings.remove": "Remove",
  "settings.add": "Add",
  "settings.nav.hours": "Opening hours",
  "settings.nav.staff": "Staff and resources",
  "settings.nav.services": "Services and prices",
  "settings.nav.rules": "Booking rules",
  "settings.nav.reminders": "Reminders",
  "settings.nav.mobile": "Mobile unit",
  "settings.nav.profile": "Profile",
  "settings.nav.calendar": "Calendar sync",
  "settings.calendar.heading": "Calendar sync",
  "settings.calendar.body": "Connect Google Calendar and the ColorGlo jobs show up where your staff already look. Bookings keep working even when Google is down.",
  "settings.calendar.unavailable": "Google Calendar is not switched on in this environment. Get in touch with support.",
  "settings.calendar.connections": "Connected accounts",
  "settings.calendar.connect": "Connect Google Calendar",
  "settings.calendar.reconnect": "Reconnect",
  "settings.calendar.disconnect": "Disconnect",
  "settings.calendar.sync_now": "Sync now",
  "settings.calendar.syncing": "Syncing …",
  "settings.calendar.queued": "The sync is queued.",
  "settings.calendar.status.connected": "Connected",
  "settings.calendar.status.degraded": "Needs reconnecting",
  "settings.calendar.status.disconnected": "Not connected",
  "settings.calendar.last_synced": "Last synced {when}",
  "settings.calendar.never_synced": "Never synced",
  "settings.calendar.pending.one": "{count} job waiting to be sent",
  "settings.calendar.pending.other": "{count} jobs waiting to be sent",
  "settings.calendar.disconnect_confirm": "Disconnect {account}? ColorGlo's bookings are removed from the calendar.",
  "settings.calendar.disconnect_keep": "Disconnect and keep the events",
  "settings.calendar.disconnected": "The connection is gone.",
  "settings.calendar.privacy.heading": "What shows in the calendar",
  "settings.calendar.privacy.body": "Applies to every connected account at the workshop. A technician's phone shows the calendar on the lock screen, so pick no more than you need.",
  "settings.calendar.privacy.full": "Full details",
  "settings.calendar.privacy.full_hint": "Service, the customer's first name, phone and address.",
  "settings.calendar.privacy.initials": "Initials only",
  "settings.calendar.privacy.initials_hint": "Service and the customer's initials. No phone.",
  "settings.calendar.privacy.busy": "Just “Busy”",
  "settings.calendar.privacy.busy_hint": "Nothing about the job is visible.",
  "settings.calendar.privacy.saved": "Saved. Upcoming bookings are rewritten.",
  "settings.calendar.feeds.heading": "Subscription links (ICS)",
  "settings.calendar.feeds.body": "Read-only links to subscribe to in Apple Calendar or Outlook. The link is shown once — copy it now.",
  "settings.calendar.feeds.create": "Create a link",
  "settings.calendar.feeds.rotate": "Replace the link",
  "settings.calendar.feeds.revoke": "Revoke",
  "settings.calendar.feeds.whole_franchise": "The whole workshop",
  "settings.calendar.feeds.copy": "Copy",
  "settings.calendar.feeds.copied": "The link is copied.",
  "settings.calendar.feeds.once": "This is the only time the link is shown. If you do not save it you will have to create a new one.",
  "settings.calendar.feeds.never_used": "Never fetched",
  "settings.calendar.feeds.last_used": "Fetched {when}",
  "settings.calendar.feeds.none": "No links yet.",
  "settings.hours.heading": "Opening hours",
  "settings.hours.body": "These hours decide when customers can book. Staff who follow the workshop's hours get them straight away.",
  "settings.hours.closed": "Closed",
  "settings.hours.open": "Open",
  "settings.hours.from": "From",
  "settings.hours.to": "To",
  "settings.hours.add_break": "Add a break",
  "settings.hours.break_hint": "Two rows on the same day mean you are closed in between.",
  "settings.hours.overlap": "The hours on the same day overlap each other.",
  "settings.hours.order": "The end time has to be after the start time.",
  "settings.hours.holidays": "Public holidays",
  "settings.hours.holidays_body": "Tick the days you keep closed. Customers then cannot book that day.",
  "settings.hours.special": "Special days",
  "settings.hours.special_body": "Extra hours or an early close on a single day.",
  "settings.hours.special_empty": "No special days added.",
  "settings.hours.special_kind": "What applies?",
  "settings.hours.special_closed": "Closed all day",
  "settings.hours.special_extra": "Extra hours",
  "settings.hours.special_date": "Date",
  "settings.hours.special_reason": "Reason",
  "settings.staff.heading": "Staff and resources",
  "settings.staff.body": "Everyone who does the work, and the vans and bays that get booked. Each row becomes its own column in the calendar.",
  "settings.staff.name": "Name",
  "settings.staff.type": "Type",
  "settings.staff.type.staff": "Person",
  "settings.staff.type.van": "Van",
  "settings.staff.type.bay": "Bay",
  "settings.staff.color": "Colour in the calendar",
  "settings.staff.bookable": "Can be booked",
  "settings.staff.active": "Active",
  "settings.staff.inherits": "Follows the workshop's opening hours",
  "settings.staff.own_hours": "Own working hours",
  "settings.staff.skills": "Performs these services",
  "settings.staff.skills_empty": "No service picked — nothing can be booked here.",
  "settings.staff.add": "Add a person or a resource",
  "settings.staff.added": "Added.",
  "settings.staff.remove": "Remove",
  "settings.staff.remove_heading": "Remove {name}?",
  "settings.staff.remove_body.one": "{count} upcoming booking is assigned to {name}.",
  "settings.staff.remove_body.other": "{count} upcoming bookings are assigned to {name}.",
  "settings.staff.remove_none": "{name} has no upcoming bookings.",
  "settings.staff.remove_assign_body": "Choose who takes each booking. Anyone already busy at that time can't be picked.",
  "settings.staff.remove_assign_all": "Give every time they are free to",
  "settings.staff.remove_free_count": "free for {free} of {count}",
  "settings.staff.remove_pick": "Choose a person",
  "settings.staff.remove_option_free": "Free",
  "settings.staff.remove_option_busy": "Busy",
  "settings.staff.remove_option_hours": "Outside working hours",
  "settings.staff.remove_option_skill": "Doesn't do this service",
  "settings.staff.remove_progress": "{done} of {count} bookings have a new person.",
  "settings.staff.remove_no_candidates": "Nobody else can take these bookings. Add a person first, then move the bookings.",
  "settings.staff.remove_conflict": "{name} was booked at that time in the meantime. Choose someone else for this booking.",
  "settings.staff.remove_new_booking": "A new booking came in meanwhile. Choose who takes it too.",
  "settings.staff.remove_no_customer": "No customer",
  "settings.staff.remove_confirm": "Remove and move the bookings",
  "settings.staff.remove_confirm_empty": "Remove",
  "settings.staff.deactivate": "Deactivate instead",
  "settings.staff.deactivate_hint": "A deactivated person disappears from the calendar but keeps their history.",
  "settings.staff.deactivated_notice": "{name} was deactivated to keep their booking history.",
  "settings.staff.reactivate": "Reactivate",
  "settings.staff.invite": "Invite by email",
  "settings.staff.invite_email": "Email address",
  "settings.staff.invite_send": "Create the invitation",
  "settings.staff.invite_pending": "Waiting for a reply",
  "settings.staff.invite_link": "Send this link to {email}:",
  "settings.staff.invite_copy": "Copy the link",
  "settings.staff.invite_copied": "The link is copied.",
  "settings.staff.invite_revoke": "Withdraw",
  "settings.staff.invite_expires": "The link works until {date}.",
  "settings.services.heading": "Services and prices",
  "settings.services.body": "The network's services. Switch on what you do, and change the time or the price where you differ.",
  "settings.services.enabled": "Offered here",
  "settings.services.inherited": "The network's value: {value}",
  "settings.services.duration": "Time",
  "settings.services.price": "Price",
  "settings.services.buffer_before": "Preparation before",
  "settings.services.buffer_after": "Clearing up after",
  "settings.services.max_per_day": "Max per day",
  "settings.services.max_per_day_hint": "0 means no limit.",
  "settings.services.assessment": "Requires an assessment",
  "settings.services.assessment_hint": "The customer books a short assessment and gets a quote afterwards — no price is shown.",
  "settings.services.reset": "Use the network's value",
  "settings.services.minutes": "minutes",
  "settings.services.disable_heading": "Stop offering {name}?",
  "settings.services.disable_body.one": "The service disappears from booking on the web straight away. {count} upcoming booking is unaffected.",
  "settings.services.disable_body.other": "The service disappears from booking on the web straight away. {count} upcoming bookings are unaffected.",
  "settings.services.disable_confirm": "Stop offering it",
  "settings.rules.heading": "Booking rules",
  "settings.rules.body": "The limits on what a customer can book themselves on the web.",
  "settings.rules.min_notice": "How late can customers book?",
  "settings.rules.min_notice_hint": "Times closer than this cannot be booked on the web. You can always book them yourselves.",
  "settings.rules.max_horizon": "How far ahead can customers book?",
  "settings.rules.max_horizon_hint": "The calendar on the web shows no further ahead than this.",
  "settings.rules.granularity": "How close together are the times?",
  "settings.rules.granularity_hint": "The customer picks from even intervals — 30 minutes is the usual one.",
  "settings.rules.auto_confirm": "Confirm bookings automatically",
  "settings.rules.auto_confirm_hint": "The customer is confirmed straight away. With it off, the customer is told you will get back to them.",
  "settings.rules.same_day": "Allow same-day booking",
  "settings.rules.cancellation": "How late can a customer cancel themselves?",
  "settings.rules.cancellation_hint": "Later than this and the customer has to ring you instead. Cancelling should never be harder than booking.",
  "settings.rules.max_per_day": "Max bookings per day",
  "settings.rules.max_per_day_hint": "0 means no limit.",
  "settings.rules.hours": "hours",
  "settings.rules.days": "days",
  "settings.rules.minutes": "minutes",
  "settings.reminders.heading": "Reminders",
  "settings.reminders.body": "One email per row. Read the row out loud — if it says the right thing, it does the right thing.",
  "settings.reminders.sentence": "Send {channel} {offset} {event}",
  "settings.reminders.channel.email": "an email",
  "settings.reminders.offset.before": "{value} before",
  "settings.reminders.offset.after": "{value} after",
  "settings.reminders.offset.immediately": "straight away on",
  "settings.reminders.event.booked": "a booked time",
  "settings.reminders.event.confirmed": "a confirmed booking",
  "settings.reminders.event.rescheduled": "a moved booking",
  "settings.reminders.event.cancelled": "a cancellation",
  "settings.reminders.event.no_show": "a customer who did not turn up",
  "settings.reminders.event.completed": "a finished job",
  "settings.reminders.template": "Email",
  "settings.reminders.template_name.booking_confirmed": "Booking confirmation",
  "settings.reminders.template_name.reminder": "Reminder",
  "settings.reminders.template_name.rescheduled": "Booking moved",
  "settings.reminders.template_name.cancelled": "Cancellation",
  "settings.reminders.template_name.assessment_booked": "Assessment booked",
  "settings.reminders.template_name.job_completed": "Job completed",
  "settings.reminders.template_name.review_request": "Review request",
  "settings.reminders.template_name.no_show_followup": "No-show follow-up",
  "settings.reminders.template_name.waitlist_slot_open": "Waitlist slot open",
  "settings.reminders.when": "When",
  "settings.reminders.when_before": "Before the time",
  "settings.reminders.when_after": "After the event",
  "settings.reminders.amount": "How far",
  "settings.reminders.unit.hours": "hours",
  "settings.reminders.unit.days": "days",
  "settings.reminders.service": "Applies to service",
  "settings.reminders.service_all": "All services",
  "settings.reminders.active": "On",
  "settings.reminders.add": "Add a reminder",
  "settings.reminders.empty": "No reminders yet. Add one and you get in touch in good time.",
  "settings.reminders.remove_heading": "Remove the reminder?",
  "settings.reminders.remove_body": "Upcoming messages from this rule are called off. Emails already sent stay in the log.",
  "settings.reminders.move_up": "Move up",
  "settings.reminders.move_down": "Move down",
  "settings.reminders.preview": "Preview",
  "settings.reminders.preview_locale": "Language",
  "settings.reminders.preview_subject": "Subject",
  "settings.reminders.test": "Send a test to me",
  "settings.reminders.test_sent": "The test email is on its way to you.",
  "settings.reminders.test_redirected": "The test email went to the development address.",
  "settings.mobile.heading": "Mobile unit",
  "settings.mobile.body": "Where you set off from, how far you travel, and what the journey costs.",
  "settings.mobile.base": "Starting point",
  "settings.mobile.base_hint": "The day starts and ends here. Travel time is counted from this address.",
  "settings.mobile.address": "Address",
  "settings.mobile.postcode": "Postcode",
  "settings.mobile.city": "Town or city",
  "settings.mobile.latitude": "Latitude",
  "settings.mobile.longitude": "Longitude",
  "settings.mobile.radius": "How far do you travel?",
  "settings.mobile.radius_hint": "Customers outside the area cannot book you on the web.",
  "settings.mobile.km": "km",
  "settings.mobile.speed": "Average speed",
  "settings.mobile.speed_unit": "km/h",
  "settings.mobile.speed_hint": "Used to work out travel time between jobs. 50 km/h suits most.",
  "settings.mobile.setup": "Time for loading and setting up",
  "settings.mobile.surcharge": "Surcharge per kilometre",
  "settings.mobile.postcodes": "Postcodes you travel to",
  "settings.mobile.postcodes_hint": "One postcode per row. Leave it empty if you would rather use the area above.",
  "settings.mobile.polygon_note": "A drawn area already exists and is used as well.",
  "settings.profile.heading": "Profile",
  "settings.profile.body": "This is what customers see about you — in booking and in the emails.",
  "settings.profile.display_name": "Public name",
  "settings.profile.phone": "Phone",
  "settings.profile.email": "Email customers reply to",
  "settings.profile.email_hint": "Replies to booking emails land here.",
  "settings.profile.address": "Street address",
  "settings.profile.address2": "Address line 2",
  "settings.profile.description": "About the workshop",
  "settings.profile.description_hint": "Two sentences is enough. Write the way you talk.",
  "settings.profile.logo": "Your own logo",
  "settings.profile.logo_hint": "The address of an image, starting with https.",
  "settings.profile.review_url": "Link for reviews",
  "settings.profile.photos": "Pictures",
  "settings.profile.photos_hint": "One image address per row, all of them https.",
  "settings.reports.title": "Reports",
  "settings.reports.body": "Have your figures emailed automatically. The report covers this location only.",
  "settings.reports.add": "Add a report",
  "settings.reports.edit": "Edit report",
  "settings.reports.empty": "No reports are scheduled yet.",
  "settings.reports.recipient": "Recipient",
  "settings.reports.recipient_help": "Only people who work here can be chosen.",
  "settings.reports.period": "How often",
  "settings.reports.period.weekly": "Every week",
  "settings.reports.period.monthly": "Every month",
  "settings.reports.weekday": "Day",
  "settings.reports.day_of_month": "Day of the month",
  "settings.reports.hour": "Time",
  "settings.reports.metrics": "Figures to include",
  "settings.reports.include_csv": "Attach a spreadsheet (CSV)",
  "settings.reports.active": "Active",
  "settings.reports.sentence.weekly": "Send a weekly report every {weekday} at {hour} to {recipient}",
  "settings.reports.sentence.monthly": "Send a monthly report on day {day} at {hour} to {recipient}",
  "settings.reports.paused": "Paused",
  "settings.reports.send_test": "Send a test to me",
  "settings.reports.test_sent": "The test report is on its way to {email}.",
  "settings.reports.saved": "Report saved.",
  "settings.reports.deleted": "Report removed.",
  "settings.reports.delete": "Remove",
  "settings.reports.last_sent": "Last sent for the period ending {date}",
  "settings.reports.never_sent": "Not sent yet",
  "settings.reports.history": "Sent reports",
  "settings.reports.history_empty": "Nothing has been sent yet.",
  "settings.reports.status.pending": "Queued",
  "settings.reports.status.sent": "Sent",
  "settings.reports.status.failed": "Failed",
  "settings.reports.status.skipped": "Skipped",
  "settings.reports.status.cancelled": "Cancelled",
  "settings.reports.no_metrics": "Choose at least one figure.",
  "settings.reports.duplicate": "This person already gets a report at the same interval.",
  "weekday.1": "Monday",
  "weekday.2": "Tuesday",
  "weekday.3": "Wednesday",
  "weekday.4": "Thursday",
  "weekday.5": "Friday",
  "weekday.6": "Saturday",
  "weekday.7": "Sunday",
  "settings.nav.reports": "Reports",
  "settings.nav.integrations": "Integrations",
  "settings.messaging.heading": "Messages to customers",
  "settings.messaging.body": "Choose how your customers get reminders besides email. Customers who have not given a mobile number only get email.",
  "settings.messaging.none": "HQ has not switched on any SMS or WhatsApp provider yet.",
  "settings.messaging.one_at_a_time": "One at a time. If you switch provider, upcoming reminders go through the new one.",
  "settings.messaging.sender": "Sender name",
  "settings.messaging.sender.hint": "The name the customer sees, for example CGAvesta. 3–11 letters or digits, no spaces. Leave empty for ColorGlo HQ's default name.",
  "settings.messaging.sender.invalid": "Use 3–11 letters or digits, no spaces, starting with a letter.",
  "settings.messaging.active.hint": "When it is off, customers only get email.",
  "settings.integrations.title": "Integrations",
  "settings.integrations.by": "By {vendor}",
  "settings.integrations.steps": "{count} steps",
  "settings.integrations.view": "View instructions",
  "settings.integrations.close": "Close",
  "settings.integrations.crumb": "Integrations / {name}",
  "settings.integrations.how": "How it works",
  "settings.integrations.setup": "Getting started",
  "settings.integrations.configure": "Connect",
  "settings.integrations.verify.body": "Checks the keys against the provider without sending anything.",
  "settings.integrations.channel.email": "Email",
  "settings.integrations.channel.sms": "SMS",
  "settings.integrations.channel.whatsapp": "WhatsApp",
  "settings.integrations.status.always_on": "Always on",
  "settings.integrations.status.not_connected": "Not connected",
  "settings.integrations.status.unverified": "Not verified",
  "settings.integrations.status.error": "Connection error",
  "settings.integrations.status.verified": "Verified",
  "settings.integrations.status.unavailable": "Not switched on by HQ",
  "settings.integrations.status.available": "Available",
  "settings.integrations.status.active": "Active",
  "settings.integrations.how.email": "Booking confirmations and reminders are always emailed to customers who gave an email address. This applies to every workshop, whatever is chosen for SMS or WhatsApp.",
  "settings.integrations.how.sms": "Reminders are sent as SMS to customers who gave a mobile number. Customers without one only get email. Each SMS costs a small amount, which ColorGlo HQ pays.",
  "settings.integrations.how.whatsapp": "Reminders are sent as WhatsApp messages to customers who opted in. Customers without WhatsApp only get email.",
  "settings.integrations.email_resend.name": "Email",
  "settings.integrations.email_resend.description": "Customer email is sent from ColorGlo HQ's Resend account. Always on.",
  "settings.integrations.email_resend.hq.step.1": "The domain send.colorglo.se is verified with Resend.",
  "settings.integrations.email_resend.hq.step.2": "The API key is set by the developers in the server environment, not here.",
  "settings.integrations.email_resend.hq.step.3": "Nothing else is needed. Every workshop sends email automatically.",
  "settings.integrations.email_resend.owner.step.1": "Email is always on for your workshop.",
  "settings.integrations.email_resend.owner.step.2": "Customers get their booking confirmation and reminders by email.",
  "settings.integrations.email_resend.owner.step.3": "Change when reminders go out under Reminders.",
  "settings.integrations.sms_elks46.name": "46elks",
  "settings.integrations.sms_elks46.description": "Swedish SMS provider with data in the EU. Paid per SMS sent.",
  "settings.integrations.sms_elks46.hq.step.1": "Create an account at 46elks.se and top up the balance.",
  "settings.integrations.sms_elks46.hq.step.2": "Open Account in the 46elks dashboard and copy the API username and API password.",
  "settings.integrations.sms_elks46.hq.step.3": "Paste the keys below and set a default sender name, for example ColorGlo.",
  "settings.integrations.sms_elks46.hq.step.4": "Test the connection, then switch 46elks on for the workshops.",
  "settings.integrations.sms_elks46.owner.step.1": "Switch 46elks on here. It replaces another SMS or WhatsApp provider if you had one.",
  "settings.integrations.sms_elks46.owner.step.2": "Set your own sender name, for example CGAvesta, or leave it empty for ColorGlo's name.",
  "settings.integrations.sms_elks46.owner.step.3": "Customers who give a mobile number get SMS reminders. Everyone else gets email.",
  "settings.integrations.sms_prelude.name": "Prelude SMS",
  "settings.integrations.sms_prelude.description": "SMS through Prelude, which switches carriers automatically for high delivery rates.",
  "settings.integrations.sms_prelude.hq.step.1": "Sign in to the Prelude dashboard and create an API key under API Keys.",
  "settings.integrations.sms_prelude.hq.step.2": "Ask Prelude to create a test template without variables, and the booking confirmation and reminder templates in Swedish, Norwegian and English.",
  "settings.integrations.sms_prelude.hq.step.3": "Paste the API key and the test template ID below. The sender name must be approved in Prelude.",
  "settings.integrations.sms_prelude.hq.step.4": "Test the connection, send a test to yourself, then switch Prelude on for the workshops. The test message is the real check: the connection test can accept a key that still is not allowed to send.",
  "settings.integrations.sms_prelude.owner.step.1": "Switch Prelude SMS on here. It replaces another SMS or WhatsApp provider if you had one.",
  "settings.integrations.sms_prelude.owner.step.2": "Set your own sender name or leave it empty for ColorGlo's name. HQ needs to have the name approved at Prelude.",
  "settings.integrations.sms_prelude.owner.step.3": "Customers who give a mobile number get SMS reminders. Everyone else gets email.",
  "settings.integrations.whatsapp_meta.name": "WhatsApp",
  "settings.integrations.whatsapp_meta.description": "WhatsApp directly from Meta. The customer needs WhatsApp and must opt in to messages.",
  "settings.integrations.whatsapp_meta.hq.step.1": "Verify ColorGlo as a business in Meta Business Manager and add a phone number under WhatsApp.",
  "settings.integrations.whatsapp_meta.hq.step.2": "Create a system user with the whatsapp_business_messaging permission and generate a permanent token.",
  "settings.integrations.whatsapp_meta.hq.step.3": "Paste the token and the phone number ID below. hello_world is used as the test message.",
  "settings.integrations.whatsapp_meta.hq.step.4": "Test the connection, send a test to yourself, then switch WhatsApp on for the workshops.",
  "settings.integrations.whatsapp_meta.owner.step.1": "Switch WhatsApp on here. It replaces SMS if you had chosen it.",
  "settings.integrations.whatsapp_meta.owner.step.2": "Messages come from ColorGlo's approved WhatsApp number. You do not need to set a sender name.",
  "settings.integrations.whatsapp_meta.owner.step.3": "Customers who opt in get reminders in WhatsApp. Everyone else gets email.",
  "settings.integrations.whatsapp_prelude.name": "Prelude WhatsApp",
  "settings.integrations.whatsapp_prelude.description": "WhatsApp through Prelude, with the same account and templates as Prelude SMS.",
  "settings.integrations.whatsapp_prelude.hq.step.1": "Sign in to the Prelude dashboard and create an API key, or use the one for Prelude SMS.",
  "settings.integrations.whatsapp_prelude.hq.step.2": "Ask Prelude to connect a WhatsApp number and set up the templates as WhatsApp only, so they never fall back to SMS.",
  "settings.integrations.whatsapp_prelude.hq.step.3": "Paste the API key and the test template ID below.",
  "settings.integrations.whatsapp_prelude.hq.step.4": "Test the connection, send a test to yourself, then switch Prelude WhatsApp on for the workshops. The test message is the real check: the connection test can accept a key that still is not allowed to send.",
  "settings.integrations.whatsapp_prelude.owner.step.1": "Switch Prelude WhatsApp on here. It replaces SMS if you had chosen it.",
  "settings.integrations.whatsapp_prelude.owner.step.2": "Messages come from ColorGlo's WhatsApp number at Prelude. You do not need to set a sender name.",
  "settings.integrations.whatsapp_prelude.owner.step.3": "Customers who opt in get reminders in WhatsApp. Everyone else gets email.",
  "settings.messaging.active_via": "Send reminders through {provider}",
  "settings.messaging.sender.after_choosing": "Switch {provider} on to choose a sender name.",
  "settings.messaging.sender.whatsapp": "WhatsApp messages come from ColorGlo's approved number, so there is no sender name to choose.",
  "settings.integrations.sms_twilio.name": "Twilio",
  "settings.integrations.sms_twilio.description": "SMS through Twilio, a global provider. Paid per SMS sent.",
  "settings.integrations.sms_twilio.hq.step.1": "Create or sign in to an account at twilio.com and upgrade it from trial mode.",
  "settings.integrations.sms_twilio.hq.step.2": "Copy the Account SID and Auth Token from the Twilio Console home page.",
  "settings.integrations.sms_twilio.hq.step.3": "Paste them below and set a default sender: a name like ColorGlo or a Twilio number.",
  "settings.integrations.sms_twilio.hq.step.4": "Test the connection, send a test to yourself, then switch Twilio on for the workshops.",
  "settings.integrations.sms_twilio.owner.step.1": "Switch Twilio on here. It replaces another SMS or WhatsApp provider if you had one.",
  "settings.integrations.sms_twilio.owner.step.2": "Set your own sender name, for example CGAvesta, or leave it empty for ColorGlo's name.",
  "settings.integrations.sms_twilio.owner.step.3": "Customers who give a mobile number get SMS reminders. Everyone else gets email.",
  "settings.rules.inspection": "Inspection length",
  "settings.rules.inspection_hint": "How long each booking gets. The job's price and time are agreed with the customer after the inspection.",
  "settings.staff.open": "Open",
  "settings.staff.back": "Staff & resources",
  "settings.staff.tab.overview": "Overview",
  "settings.staff.tab.profile": "Profile",
  "settings.staff.tab.schedule": "Schedule",
  "settings.staff.tab.time_off": "Time off",
  "settings.staff.tab.activity": "Activity",
  "settings.staff.role.franchise_owner": "Owner",
  "settings.staff.role.franchise_staff": "Staff",
  "settings.staff.status.active": "Active",
  "settings.staff.status.inactive": "Deactivated",
  "settings.staff.no_account": "{name} has no login. Invite them by email to give them access.",
  "settings.staff.account.heading": "Login",
  "settings.staff.account.body": "The name and email address this person signs in with.",
  "settings.staff.account.name": "Name",
  "settings.staff.account.email": "Email address",
  "settings.staff.account.email_hint": "We'll notify both the old and the new address.",
  "settings.staff.account.phone": "Phone",
  "settings.staff.account.language": "Language",
  "settings.staff.account.saved": "Saved.",
  "settings.staff.account.owner_locked": "Owner accounts are changed by HQ.",
  "settings.staff.account.shared": "{name} also works at another workshop. Their email address and sign-out are handled by HQ.",
  "settings.staff.security.heading": "Security",
  "settings.staff.security.last_active": "Last active {when}",
  "settings.staff.security.never": "Hasn't signed in yet",
  "settings.staff.security.sessions.one": "Signed in on {count} device",
  "settings.staff.security.sessions.other": "Signed in on {count} devices",
  "settings.staff.security.reset": "Send new password link",
  "settings.staff.security.reset_title": "Send a link to {email}?",
  "settings.staff.security.reset_body": "The link is valid for 24 hours. The old password keeps working until a new one is chosen.",
  "settings.staff.security.reset_send": "Send link",
  "settings.staff.security.reset_sent": "Link sent to {email}.",
  "settings.staff.security.sign_out": "Sign out of all devices",
  "settings.staff.security.sign_out_title": "Sign {name} out everywhere?",
  "settings.staff.security.sign_out_body": "{name} will be signed out on every device and has to sign in again.",
  "settings.staff.security.sign_out_confirm": "Sign out",
  "settings.staff.security.signed_out": "{name} is signed out.",
  "settings.staff.schedule.heading": "Calendar and working hours",
  "settings.staff.schedule.body": "How {name} appears in the calendar, when they work and which services they do.",
  "settings.staff.schedule.calendar_name": "Name in the calendar",
  "settings.staff.danger.heading": "Deactivate",
  "settings.staff.danger.body": "{name} disappears from the calendar and is signed out. Their login is closed, Google Calendar is disconnected and calendar feeds stop working. History is kept.",
  "settings.staff.danger.deactivate": "Deactivate {name}",
  "settings.staff.danger.reactivate_body": "{name} is deactivated. Reactivate to bring back the calendar column and the login.",
  "settings.staff.invite_resend": "Send again",
  "settings.staff.invite_resent": "Invitation sent again.",
  "settings.staff.time_off.heading": "Time off",
  "settings.staff.time_off.body": "Vacation, sick leave and training. The time can't be booked.",
  "settings.staff.time_off.add": "Add time off",
  "settings.staff.time_off.from": "From",
  "settings.staff.time_off.to": "Until",
  "settings.staff.time_off.start": "Start time",
  "settings.staff.time_off.end": "End time",
  "settings.staff.time_off.reason": "Note",
  "settings.staff.time_off.added": "Time off saved.",
  "settings.staff.time_off.removed": "Time off removed.",
  "settings.staff.time_off.upcoming": "Upcoming",
  "settings.staff.time_off.past": "Past year",
  "settings.staff.time_off.empty": "No time off recorded.",
  "settings.staff.time_off.days.one": "{count} day",
  "settings.staff.time_off.days.other": "{count} days",
  "settings.staff.time_off.training_hint": "Training needs a start and end time.",
  "settings.staff.time_off.invalid_range": "The end date must be the same day or later, and at most 120 days on.",
  "settings.staff.activity.heading": "Activity",
  "settings.staff.activity.body": "What has changed for {name}, and who changed it.",
  "settings.staff.activity.empty": "Nothing has changed yet.",
  "settings.staff.activity.via_hq": "via HQ",
  "settings.staff.activity.system": "The system",
  "settings.staff.activity.resource_created": "Added",
  "settings.staff.activity.resource_updated": "Calendar or schedule changed",
  "settings.staff.activity.resource_deactivated": "Deactivated",
  "settings.staff.activity.staff_account_updated": "Login details changed",
  "settings.staff.activity.password_reset_sent": "Sent a new password link",
  "settings.staff.activity.password_reset_completed": "Chose a new password",
  "settings.staff.activity.staff_signed_out": "Signed out of all devices",
  "settings.staff.activity.blocker_created": "Time off added: {kind}, {date}",
  "settings.staff.activity.blocker_deleted": "Time off removed: {kind}, {date}",
  "settings.staff.activity.other": "Change",
  "settings.staff.overview.heading": "Overview",
  "settings.staff.overview.body": "How {name} is doing. Only you as the owner can see these numbers.",
  "settings.staff.overview.period": "Period",
  "settings.staff.overview.period.30": "Last 30 days",
  "settings.staff.overview.period.90": "Last 90 days",
  "settings.staff.overview.period.365": "Last 12 months",
  "settings.staff.overview.previous": "{value} the period before",
  "settings.staff.overview.kpi.jobs_completed": "Jobs completed",
  "settings.staff.overview.kpi.worked": "Hours worked",
  "settings.staff.overview.kpi.revenue": "Revenue",
  "settings.staff.overview.kpi.job_value": "Average job value",
  "settings.staff.overview.kpi.utilisation": "Utilisation",
  "settings.staff.overview.kpi.no_show_rate": "No-shows",
  "settings.staff.overview.kpi.cancellation_rate": "Cancellations",
  "settings.staff.overview.hours": "{hours} h",
  "settings.staff.overview.hint.utilisation": "Booked time divided by working time, the same calculation as for the workshop.",
  "settings.staff.overview.time_off": "Time off in the period",
  "settings.staff.overview.days": "{days} days",
  "settings.staff.overview.chart.jobs": "Jobs completed",
  "settings.staff.overview.chart.utilisation": "Utilisation",
  "settings.staff.overview.chart.table": "Show as table",
  "settings.staff.overview.chart.period": "Period",
  "settings.staff.overview.services": "Jobs by service",
  "settings.staff.overview.services.jobs": "Jobs",
  "settings.staff.overview.services.service": "Service",
  "settings.staff.overview.recent": "Latest jobs",
  "settings.staff.overview.empty": "No jobs in this period."
}
